import { render } from "./social_media.vue?vue&type=template&id=eb144774"
import script from "./social_media.vue?vue&type=script&lang=js"
export * from "./social_media.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__